/*! magnet-uri. MIT License. WebTorrent LLC <https://webtorrent.io/opensource> */
module.exports = magnetURIDecode;
module.exports.decode = magnetURIDecode;
module.exports.encode = magnetURIEncode;

var base32 = require('thirty-two');

var bep53Range = require('bep53-range');
/**
 * Parse a magnet URI and return an object of keys/values
 *
 * @param  {string} uri
 * @return {Object} parsed uri
 */


function magnetURIDecode(uri) {
  var result = {}; // Support 'magnet:' and 'stream-magnet:' uris

  var data = uri.split('magnet:?')[1];
  var params = data && data.length >= 0 ? data.split('&') : [];
  params.forEach(function (param) {
    var keyval = param.split('='); // This keyval is invalid, skip it

    if (keyval.length !== 2) return;
    var key = keyval[0];
    var val = keyval[1]; // Clean up torrent name

    if (key === 'dn') val = decodeURIComponent(val).replace(/\+/g, ' '); // Address tracker (tr), exact source (xs), and acceptable source (as) are encoded
    // URIs, so decode them

    if (key === 'tr' || key === 'xs' || key === 'as' || key === 'ws') {
      val = decodeURIComponent(val);
    } // Return keywords as an array


    if (key === 'kt') val = decodeURIComponent(val).split('+'); // Cast file index (ix) to a number

    if (key === 'ix') val = Number(val); // bep53

    if (key === 'so') val = bep53Range.parse(decodeURIComponent(val).split(',')); // If there are repeated parameters, return an array of values

    if (result[key]) {
      if (!Array.isArray(result[key])) {
        result[key] = [result[key]];
      }

      result[key].push(val);
    } else {
      result[key] = val;
    }
  }); // Convenience properties for parity with `parse-torrent-file` module

  var m;

  if (result.xt) {
    var xts = Array.isArray(result.xt) ? result.xt : [result.xt];
    xts.forEach(function (xt) {
      if (m = xt.match(/^urn:btih:(.{40})/)) {
        result.infoHash = m[1].toLowerCase();
      } else if (m = xt.match(/^urn:btih:(.{32})/)) {
        var decodedStr = base32.decode(m[1]);
        result.infoHash = Buffer.from(decodedStr, 'binary').toString('hex');
      }
    });
  }

  if (result.xs) {
    var xss = Array.isArray(result.xs) ? result.xs : [result.xs];
    xss.forEach(function (xs) {
      if (m = xs.match(/^urn:btpk:(.{64})/)) {
        result.publicKey = m[1].toLowerCase();
      }
    });
  }

  if (result.infoHash) result.infoHashBuffer = Buffer.from(result.infoHash, 'hex');
  if (result.publicKey) result.publicKeyBuffer = Buffer.from(result.publicKey, 'hex');
  if (result.dn) result.name = result.dn;
  if (result.kt) result.keywords = result.kt;
  result.announce = [];

  if (typeof result.tr === 'string' || Array.isArray(result.tr)) {
    result.announce = result.announce.concat(result.tr);
  }

  result.urlList = [];

  if (typeof result.as === 'string' || Array.isArray(result.as)) {
    result.urlList = result.urlList.concat(result.as);
  }

  if (typeof result.ws === 'string' || Array.isArray(result.ws)) {
    result.urlList = result.urlList.concat(result.ws);
  }

  result.peerAddresses = [];

  if (typeof result['x.pe'] === 'string' || Array.isArray(result['x.pe'])) {
    result.peerAddresses = result.peerAddresses.concat(result['x.pe']);
  } // remove duplicates by converting to Set and back


  result.announce = Array.from(new Set(result.announce));
  result.urlList = Array.from(new Set(result.urlList));
  result.peerAddresses = Array.from(new Set(result.peerAddresses));
  return result;
}

function magnetURIEncode(obj) {
  obj = Object.assign({}, obj); // clone obj, so we can mutate it
  // support using convenience names, in addition to spec names
  // (example: `infoHash` for `xt`, `name` for `dn`)

  if (obj.infoHashBuffer) obj.xt = "urn:btih:".concat(obj.infoHashBuffer.toString('hex'));
  if (obj.infoHash) obj.xt = "urn:btih:".concat(obj.infoHash);
  if (obj.publicKeyBuffer) obj.xs = "urn:btpk:".concat(obj.publicKeyBuffer.toString('hex'));
  if (obj.publicKey) obj.xs = "urn:btpk:".concat(obj.publicKey);
  if (obj.name) obj.dn = obj.name;
  if (obj.keywords) obj.kt = obj.keywords;
  if (obj.announce) obj.tr = obj.announce;

  if (obj.urlList) {
    obj.ws = obj.urlList;
    delete obj.as;
  }

  if (obj.peerAddresses) obj['x.pe'] = obj.peerAddresses;
  var result = 'magnet:?';
  Object.keys(obj).filter(function (key) {
    return key.length === 2 || key === 'x.pe';
  }).forEach(function (key, i) {
    var values = Array.isArray(obj[key]) ? obj[key] : [obj[key]];
    values.forEach(function (val, j) {
      if ((i > 0 || j > 0) && (key !== 'kt' && key !== 'so' || j === 0)) result += '&';
      if (key === 'dn') val = encodeURIComponent(val).replace(/%20/g, '+');

      if (key === 'tr' || key === 'as' || key === 'ws') {
        val = encodeURIComponent(val);
      } // Don't URI encode BEP46 keys


      if (key === 'xs' && !val.startsWith('urn:btpk:')) {
        val = encodeURIComponent(val);
      }

      if (key === 'kt') val = encodeURIComponent(val);
      if (key === 'so') return;
      if (key === 'kt' && j > 0) result += "+".concat(val);else result += "".concat(key, "=").concat(val);
    });
    if (key === 'so') result += "".concat(key, "=").concat(bep53Range.compose(values));
  });
  return result;
}